import script from "./InfiniteScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&setup=true&lang=js"

import "./InfiniteScroll.vue?vue&type=style&index=0&id=88fbeb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88fbeb44"]])

export default __exports__